export default "__VITE_ASSET__3cv6w18R__"